import React from 'react';
import '../App.css';
import  BasketSvg from '../utils/Basket';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Basket = React.forwardRef(({ name, backgroundColor, onClick }, ref) => {
    return (
        <div className='basket-container' ref={ref}>
            <BasketSvg />
            <button
                className='basket-button'
                style={{ backgroundColor }}
                onClick={onClick}
            >
                {name}
            </button>
        </div>
    );
});

export default Basket;
